import { createClient, SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * The dashboard runs without Supabase env vars in dev — in that case we expose
 * `null` and the data layer falls back to mock fixtures sourced from
 * /Users/laurameans/Documents/projects/projects-dashboard/projects.json.
 *
 * In production both vars must be set in the Pages project settings. RLS is
 * deliberately off (single user behind Cloudflare Access).
 */
export const supabase: SupabaseClient | null =
  url && anon
    ? createClient(url, anon, {
        auth: { persistSession: false },
        realtime: { params: { eventsPerSecond: 5 } },
      })
    : null;

export const hasSupabase = supabase !== null;
